import _ from "lodash";
import React from "react";

export default function TextAreaInput({
  name,
  type = "text",
  label,
  className = "",
  placeholder,
  value,
  error,
  validation = [],
  required,
  onChange,
  disabled,
  rows = 3,
  isHTClassRequired = true,
  dataCy = "",
  showCounter = false,
  maxLength = 1000,
  ...props
}) {
  let isRequired =
    required ||
    (validation.includes("required") &&
      !(validation.includes("skip") || validation.includes("optional")));

  return (
    <div className="form-group">
      <div
        className={_.uniq(["input-block", ...className.split(" ")]).join(" ")}
      >
        {/* <div className="input-block"> */}
        <label className="input-label">
          <span className="d-flex gap-1">
            {label || placeholder || ""}{" "}
            {isRequired ? <span className="text-danger">*</span> : null}
          </span>
        </label>

        <textarea
          className={`form-control-input ${isHTClassRequired && "textarea-ht"}`}
          name={name}
          data-cy={props["data-cy"] || dataCy}
          type={type}
          label={label || placeholder || ""}
          value={value}
          // valid={!error}
          error={error}
          disabled={disabled}
          onChange={onChange}
          maxLength={maxLength}
          rows={rows}
          {...props}
        />
        <div className="d-flex justify-content-between mt-1">
          {error ? (
            <small className="text-danger">{error}</small>
          ) : (
            <div />
          )}

          {showCounter && (
            <small
              style={{
                fontSize: "11px",
                color: (value?.length || 0) >= maxLength ? "#d32f2f" : "#666",
              }}
            >
              {value?.length || 0} / {maxLength} characters
            </small>
          )}
        </div>
      </div>
    </div>
  );
}
